import { PriceType, PriceTypeMixin } from './enums/PriceType.js';

export function modifyPriceBasedOnPriceType(price, price_type, days) {
    let modifiedDays = days;
    if (PriceType.isPerNightPerPerson({ price_type: price_type })) {
        modifiedDays = modifiedDays - 1;
    }
    if (modifiedDays < 1) {
        modifiedDays = 1;
    }
    if (
        PriceType.isPerDayBased({ price_type: price_type }) ||
        PriceType.isPerNightPerPerson({ price_type: price_type })
    ) {
        return price * modifiedDays;
    } else {
        return price;
    }
}

export default {
    mixins: [PriceTypeMixin],
    methods: {
        getCentsDivider() {
            return 1_000_000;
        },
        parseToCleanInteger(number) {
            return Math.round(number);
        },
        parseFromCents(price) {
            return price / this.getCentsDivider();
        },
        parseToCents(price) {
            return price * this.getCentsDivider();
        },
        parseToCentsAndClean(price) {
            return this.parseToCleanInteger(price * this.getCentsDivider());
        },
        addVatAndClean(price, vatPercentage) {
            return this.parseToCleanInteger(price * (1 + vatPercentage / 100));
        },
        subtractVatAndClean(price, vatPercentage) {
            return this.parseToCleanInteger(price / (1 + vatPercentage / 100));
        },
        percentageOf(price, percentage) {
            return price * (percentage / 100);
        },
        inputPriceValidator(inputPrice, oldPrice, nullable = false) {
            if (inputPrice === '' && nullable) {
                return oldPrice !== '';
            }
            let modifiedPrice = parseFloat(inputPrice.replace('.', '').replace(',', '.'));
            let newPrice = this.inputPriceToCleanIntegerPrice(inputPrice);
            return !(isNaN(modifiedPrice) || newPrice === oldPrice || modifiedPrice >= 1000000); // Max price = 1,000,000;
        },
        inputPriceCleaner(inputPrice) {
            if (inputPrice === '') {
                return '';
            }
            return parseFloat(inputPrice.replace('.', '').replace(',', '.'));
        },
        inputPriceToCleanIntegerPrice(inputPrice) {
            if (inputPrice === '') {
                return '';
            }
            return this.parseToCentsAndClean(this.inputPriceCleaner(inputPrice));
        },
        modifyPriceBasedOnPriceType(price, price_type, days) {
            return modifyPriceBasedOnPriceType(price, price_type, days);
        },
    },
};
